import { UserRole } from '@sb-tools/typescript/enums/user-role.enum';
import { CustomerSettings } from '@sb-tools/typescript/models/customer-settings.model';
import { CommunityUserExtended } from '@sb-tools/typescript/models/community-user-extended.model';
import { isInboxElementVisible } from './is-inbox-element-visible.util';

export function resolveIsOnlyMyTicketsFilterDefault(
    user: Pick<CommunityUserExtended, 'isAdmin' | 'role' | 'isAllTicketsFilterDefault'> | undefined,
    customerSettings: Pick<CustomerSettings, 'isAllTicketsFilterDefault' | 'inboxElementsVisibility'> | undefined,
): boolean {
    if (!user?.isAdmin && user?.role !== UserRole.manager) {
        return true;
    }

    const isOnlyMyDefault =
        user.isAllTicketsFilterDefault == null
            ? !customerSettings?.isAllTicketsFilterDefault
            : !user.isAllTicketsFilterDefault;

    if (!isInboxElementVisible(customerSettings?.inboxElementsVisibility?.leftPanel?.wholeLeftMenu)) {
        return isOnlyMyDefault;
    }

    const isInboxVisible = isInboxElementVisible(customerSettings?.inboxElementsVisibility?.leftPanel?.inboxView);
    const isAllTicketsVisible = isInboxElementVisible(
        customerSettings?.inboxElementsVisibility?.leftPanel?.allTicketsView,
    );

    if (isOnlyMyDefault && !isInboxVisible && isAllTicketsVisible) {
        return false;
    }

    if (!isOnlyMyDefault && !isAllTicketsVisible && isInboxVisible) {
        return true;
    }

    return isOnlyMyDefault;
}
